import React from "react";
import { useLocation } from "react-router-dom";

export default function HowItWorks({
  title,
  steps,
  bgColor,
  description,
  padding,
  id,
  landing = false,
}) {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const cardBaseClasses =
    "group rounded-2xl p-4 md:p-6 flex flex-col transition-colors duration-500 cursor-pointer";
  const hoverBg = "hover:bg-[#3cab5c] bg-[#ECEEF2]";
  const hoverText = "group-hover:text-white";
  const hoverNumber = "group-hover:text-[#FFFFFF]";

  // Group steps into rows, putting any step with basis '100%' alone in its row
  const rows = [];
  let i = 0;
  while (i < steps.length) {
    if (steps[i].basis === "100%") {
      rows.push([steps[i]]);
      i += 1;
    } else {
      rows.push([steps[i], steps[i + 1]]);
      i += 2;
    }
  }

  return (
    <div id={id} className={`w-full  ${bgColor ? bgColor : ""}`}>
      <div className="lg:max-w-[1440px] w-full mx-auto">
        <div
          className={`w-full mx-auto flex flex-col gap-6 md:gap-8 ${
            padding ? padding : "md:px-12 px-5"
          } lg:gap-12 text-white py-8  lg:py-[64px] ${bgColor ? "" : ""}`}
        >
          {title && (
            <div
              className={`flex flex-col gap-3 md:gap-4 ${
                bgColor ? "justify-center items-start" : ""
              } lg:gap-5`}
            >
              {landing && (
                <h5
                  className={`${
                    bgColor
                      ? "bg-[#F8F8F8] text-[#242424] border-[#ECECEC]"
                      : "bg-[#3CAB5C1A] text-[#3CAB5C] border-[#3CAB5C]"
                  } px-3 py-1 rounded-full border font-medium w-fit`}
                >
                  {"Trusted by 20,000+ member"}
                </h5>
              )}
              <h1
                className={`${landing ? "" : "font-medium"} w-full ${
                  bgColor ? "text-white text-left" : "text-[#242424]"
                } text-[24px] md:text-[48px] lg:text-[56px] leading-tight tracking-[0]`}
              >
                {title}
              </h1>
              {description && (
                <h2
                  className={`${bgColor ? "text-white" : "text-[#242424]"} ${
                    landing ? "" : "font-medium"
                  } text-lg md:text-xl`}
                >
                  {description}
                </h2>
              )}
            </div>
          )}

          <div className="flex flex-col gap-3 md:gap-4 w-full">
            {rows.map((row, rowIndex) => (
              <div
                key={rowIndex}
                className="flex gap-3 md:gap-4 flex-col sm2:flex-row"
              >
                {row.map(
                  (step, idx) =>
                    step && (
                      <div
                        key={step.number}
                        style={{ flexBasis: step.basis }}
                        className={`${cardBaseClasses} ${hoverBg} ${
                          landing
                            ? "min-h-[200px] md:min-h-[220px]"
                            : "min-h-[180px] md:min-h-[200px]"
                        } w-full relative overflow-hidden`}
                      >
                        {/* Compact number design */}
                        <div className="absolute top-3 right-3 md:top-4 md:right-4">
                          <span
                            className={`text-2xl md:text-3xl lg:text-4xl font-bold text-[#595959] opacity-20 ${hoverNumber} transition-colors duration-500`}
                          >
                            {step.number}
                          </span>
                        </div>

                        {/* Content area with better spacing */}
                        <div className="flex flex-col gap-2 md:gap-3 flex-1 justify-center pr-12 md:pr-16">
                          <h3
                            className={`${
                              landing
                                ? "text-[#D1D1D6]  text-lg md:text-xl lg:text-xl"
                                : "font-[600] text-[#242424] text-lg md:text-xl lg:text-xl"
                            } leading-tight ${hoverText}   transition-colors duration-500`}
                          >
                            {step.title}
                          </h3>
                          <p
                            className={`${
                              landing
                                ? "text-[#D1D1D6] text-sm md:text-base font-alexandria"
                                : "text-[#242424] text-sm md:text-[18px]"
                            } ${hoverText} leading-relaxed transition-colors duration-500`}
                          >
                            {step.description}
                          </p>
                        </div>
                      </div>
                    )
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
